import CryptoJS from 'crypto-js';

/**
 * SHA256 해시 생성
 * @param data - 해시할 문자열 데이터
 * @returns SHA256 해시 문자열 (16진수)
 */
export const generateSHA256 = (data: string): string => {
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
};
